import { render } from "./InconformidadModal.vue?vue&type=template&id=67364430"
import script from "./InconformidadModal.vue?vue&type=script&lang=js"
export * from "./InconformidadModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__